/* =============================================================================
   WET BOOTS? page behaviour — gallery, menu drawer, offer selection, add to cart.
   Loaded only by layout/wetboots.liquid. Safe to load twice (guarded).
   ========================================================================== */
(function () {
  'use strict';
  if (window.WetBootsPage && window.WetBootsPage.loaded) return;
  window.WetBootsPage = window.WetBootsPage || {};
  window.WetBootsPage.loaded = true;

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    var fmt = format || window.WetBootsPage.moneyFormat || '${{amount}}';
    var value = '';
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(fmt);
    var key = m ? m[1] : 'amount';
    function num(n, precision, thousands, decimal) {
      var fixed = (Number(n) / 100).toFixed(precision);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }
    switch (key) {
      case 'amount': value = num(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = num(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = num(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', '.'); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
      default: value = num(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/<[^>]+>/g, '');
  }
  window.WetBootsPage.formatMoney = formatMoney;

  /* ---------- delivery estimate: today + min..max days, client clock ---------- */
  function updateDelivery() {
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    Array.prototype.forEach.call(document.querySelectorAll('[data-wbx-delivery]'), function (el) {
      var out = el.querySelector('[data-wbx-delivery-range]');
      if (!out) return;
      var min = parseInt(el.getAttribute('data-min'), 10); var max = parseInt(el.getAttribute('data-max'), 10);
      if (isNaN(min) || isNaN(max)) return;
      var a = new Date(); a.setDate(a.getDate() + min);
      var b = new Date(); b.setDate(b.getDate() + max);
      var fmt = function (d) { return months[d.getMonth()] + ' ' + d.getDate(); };
      out.textContent = fmt(a) + ' \u2013 ' + fmt(b);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateDelivery); else updateDelivery();
  document.addEventListener('shopify:section:load', updateDelivery);

  /* ---------- menu drawer ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-wbx-menu-open]');
    var close = e.target.closest('[data-wbx-menu-close]');
    if (!open && !close) return;
    var header = e.target.closest('[data-wbx-header]');
    var nav = header ? header.querySelector('[data-wbx-nav]') : null;
    var btn = header ? header.querySelector('[data-wbx-menu-open]') : null;
    if (!nav) return;
    var show = !!open;
    nav.hidden = !show;
    if (btn) btn.setAttribute('aria-expanded', show ? 'true' : 'false');
    document.body.style.overflow = show ? 'hidden' : '';
    if (show) { var first = nav.querySelector('[data-wbx-menu-close]'); if (first) first.focus(); }
    else if (btn) btn.focus();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var nav = document.querySelector('[data-wbx-nav]:not([hidden])');
    if (nav) { var c = nav.querySelector('[data-wbx-menu-close]'); if (c) c.click(); }
  });

  /* ---------- video play buttons ---------- */
  document.addEventListener('click', function (e) {
    var play = e.target.closest('[data-wbx-play]');
    if (!play) return;
    var wrap = play.closest('[data-wbx-video-wrap]');
    var video = wrap ? wrap.querySelector('video') : null;
    if (!video) return;
    play.hidden = true;
    var p = video.play();
    if (p && p.catch) p.catch(function () { play.hidden = false; });
  });

  /* ---------- <wbx-gallery> ---------- */
  if (!customElements.get('wbx-gallery')) {
    customElements.define('wbx-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-wbx-track]');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-wbx-slide]'));
        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-wbx-thumb]'));
        this.index = 0;
        if (!this.track) return;
        var self = this;
        this.addEventListener('click', function (e) {
          var t = e.target.closest('[data-wbx-thumb]');
          if (t) { self.goTo(parseInt(t.getAttribute('data-index'), 10)); return; }
          if (e.target.closest('[data-wbx-prev]')) self.goTo(self.index - 1);
          if (e.target.closest('[data-wbx-next]')) self.goTo(self.index + 1);
        });
        this.track.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(self.index + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(self.index - 1); }
        });
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { if (en.isIntersecting && en.intersectionRatio >= 0.6) self.setActive(self.slides.indexOf(en.target)); });
          }, { root: this.track, threshold: [0.6] });
          this.slides.forEach(function (s) { self.io.observe(s); });
        }
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); }
      goTo(i) {
        var n = this.slides.length;
        if (!n) return;
        i = (i + n) % n;
        var slide = this.slides[i];
        this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'auto' });
        this.setActive(i);
      }
      setActive(i) {
        if (i < 0) return;
        this.index = i;
        this.slides.forEach(function (s, k) { if (k === i) s.setAttribute('aria-current', 'true'); else s.removeAttribute('aria-current'); });
        this.thumbs.forEach(function (t) {
          var on = parseInt(t.getAttribute('data-index'), 10) === i;
          t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on && t.scrollIntoView) { try { t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) { /* ignore */ } }
        });
      }
    });
  }

  /* ---------- <wbx-offers>: selection, totals, add to cart ---------- */
  if (!customElements.get('wbx-offers')) {
    customElements.define('wbx-offers', class extends HTMLElement {
      connectedCallback() {
        this.demo = (this.closest('[data-wbx-product]') || {}).getAttribute ? this.closest('[data-wbx-product]').getAttribute('data-demo') === 'true' : false;
        this.format = this.getAttribute('data-money-format') || window.WetBootsPage.moneyFormat;
        this.afterAdd = this.getAttribute('data-after-add') || 'cart';
        this.cartUrl = this.getAttribute('data-cart-url') || '/cart';
        this.addUrl = this.getAttribute('data-cart-add-url') || '/cart/add';
        this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-wbx-offer]'));
        this.form = this.querySelector('[data-wbx-form]');
        this.idInput = this.querySelector('[data-wbx-id]');
        this.qtyInput = this.querySelector('[data-wbx-qty]');
        this.cta = this.querySelector('[data-wbx-cta]');
        this.ctaTotal = this.querySelector('[data-wbx-cta-total]');
        this.ctaCompare = this.querySelector('[data-wbx-cta-compare]');
        this.spinner = this.querySelector('[data-wbx-spinner]');
        this.msg = this.querySelector('[data-wbx-msg]');
        this.busy = false;
        var self = this;
        this.addEventListener('change', function (e) { if (e.target.hasAttribute('data-wbx-offer-input')) self.sync(); });
        if (this.form) this.form.addEventListener('submit', function (e) { self.submit(e); });
        // Ensure exactly one selected: first checked, else first available.
        var checked = this.cards.filter(function (c) { var r = c.querySelector('[data-wbx-offer-input]'); return r && r.checked && !r.disabled; });
        if (!checked.length) {
          var firstOk = this.cards.filter(function (c) { return c.getAttribute('data-available') === 'true'; })[0];
          if (firstOk) firstOk.querySelector('[data-wbx-offer-input]').checked = true;
        }
        this.sync();
      }
      selected() {
        for (var i = 0; i < this.cards.length; i++) {
          var r = this.cards[i].querySelector('[data-wbx-offer-input]');
          if (r && r.checked) return this.cards[i];
        }
        return null;
      }
      sync(keepMsg) {
        var card = this.selected();
        this.cards.forEach(function (c) { var r = c.querySelector('[data-wbx-offer-input]'); c.classList.toggle('is-selected', !!(r && r.checked)); });
        if (!card) { if (this.cta) this.cta.disabled = true; return; }
        var price = parseInt(card.getAttribute('data-price'), 10) || 0;
        var compare = parseInt(card.getAttribute('data-compare'), 10) || 0;
        var available = card.getAttribute('data-available') === 'true';
        if (this.idInput) this.idInput.value = card.getAttribute('data-variant-id');
        if (this.qtyInput) this.qtyInput.value = card.getAttribute('data-qty') || '1';
        if (this.ctaTotal) this.ctaTotal.textContent = formatMoney(price, this.format);
        // Per-dryer price above the selector follows the selected offer (floor to match Liquid's integer division on the cards).
        var qty = parseInt(card.getAttribute('data-qty'), 10) || 1;
        var unitEl = document.querySelector('[data-wbx-unit-price]');
        if (unitEl) {
          var now = unitEl.querySelector('[data-wbx-unit-now]'); var was = unitEl.querySelector('[data-wbx-unit-was]');
          if (now) now.textContent = formatMoney(Math.floor(price / qty), this.format);
          if (was) { var wasUnit = compare > price ? Math.floor(compare / qty) : 0; was.hidden = !wasUnit; was.textContent = wasUnit ? formatMoney(wasUnit, this.format) : ''; }
        }
        if (this.ctaCompare) { this.ctaCompare.hidden = !(compare > price); this.ctaCompare.textContent = compare > price ? formatMoney(compare, this.format) : ''; }
        if (this.cta && !this.demo) this.cta.disabled = !available || this.busy;
        if (!keepMsg) this.clearMsg();
      }
      submit(e) {
        e.preventDefault();
        if (this.demo) { this.showMsg('Demo mode: purchasing is disabled. Assign a product and turn off Demo mode.'); return; }
        if (this.busy) return;
        var card = this.selected();
        if (!card || card.getAttribute('data-available') !== 'true') { this.showMsg('This option is sold out.'); return; }
        var fd = new FormData();
        fd.append('id', card.getAttribute('data-variant-id'));
        fd.append('quantity', card.getAttribute('data-qty') || '1');
        var self = this;
        this.setBusy(true);
        fetch(this.addUrl + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
          .then(function (res) {
            if (!res.ok || res.json.status) { self.showMsg(res.json.description || res.json.message || 'Couldn’t add to cart. Try again.'); return; }
            return fetch(self.cartUrl + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
              var count = document.querySelector('[data-wbx-cart-count]');
              if (count) { count.textContent = cart.item_count; count.hidden = cart.item_count === 0; }
              if (self.afterAdd === 'cart') { window.location.href = self.cartUrl; return; }
              self.showMsg('Added to your cart. <a href="' + self.cartUrl + '">View cart</a>');
            });
          })
          .catch(function () { self.showMsg('Couldn’t reach the cart. Check your connection and try again.'); })
          .then(function () { self.setBusy(false); });
      }
      setBusy(b) {
        this.busy = b;
        if (this.cta) { this.cta.setAttribute('aria-busy', b ? 'true' : 'false'); this.cta.disabled = b; }
        if (this.spinner) this.spinner.hidden = !b;
        if (!b) this.sync(true);
      }
      showMsg(html) { if (!this.msg) return; this.msg.innerHTML = html; this.msg.hidden = false; }
      clearMsg() { if (this.msg) { this.msg.hidden = true; this.msg.innerHTML = ''; } }
    });
  }
})();
